import MapDialog from './src/main.vue'

MapDialog.install = function(Vue) {
  Vue.component(MapDialog.name, MapDialog)
}

export default MapDialog